import React, { useState } from "react";
import ActionAreaCard from "../components/Card";
import { useCommonDataContext } from "../context/CommonDataProvider";
import RepPieChart from "../components/landingComponents/RepPieChart";
import TotalSalesLineChart from "../components/landingComponents/TotalSalesLineChart";
import { useLandingDataContext } from "../context/LandingDataProvider";
import processYearComparisonData, {
  calculateYearlyTotal,
} from "../serviceFunctions/LandingPage/totalSalesInMonth";
// import processData from '../serviceFunctions/LandingPage/totalSalesInMonth';
import { monthData } from "../lib/const/yearAndMonth";
import StokistTable from "../components/landingComponents/StokistTable";
import { useNavigate } from "react-router-dom";
import { BsCurrencyRupee } from "react-icons/bs";
import { SlCalender } from "react-icons/sl";
import {
  BiCoinStack,
  BiSolidBriefcase,
  BiFirstAid,
  BiSolidCapsule,
} from "react-icons/bi";
import RankingTable from "../components/landingComponents/RankingTable";
import process_Rep_data from "../serviceFunctions/MonthlyAnalysis/rep_sales";

// Function to calculate the total amount
const calculateTotalAmount = (data) => {
  return data.reduce((total, item) => total + item.totalAmount, 0);
};

function repSortByTotalAmount(arr) {
  return arr.sort((a, b) => b.sales - a.sales);
}

const Landing = () => {
  const { totalStokist, totalProducts, totalReps, totalDoctors, stokistData } =
    useCommonDataContext();
  const navigate = useNavigate();
  const [monthAndYear, setMonthAndYear] = useState({
    month: new Date().getMonth(),
    year: new Date().getFullYear(),
  });
  const { apiData, dataFetch } = useLandingDataContext();
  const [chartData, setChartData] = useState(null);
  const [currentYearTotal, setCurrentYearTotal] = useState(0.0);
  const [preveiousYearTotal, setPreviousYearTotal] = useState(0.0);
  const [pieChartData, setPieChartData] = useState(null);
  const [currentMonthTotal, setCurrentMonthTotal] = useState(0);
  const [stokistBarChartData, setStokistBarChartData] = useState(null);
  const [topRepTable, setTopRepTable] = useState(null);

  const fetchCurrentMonthSales = async (latestDate) => {
    const userDetails = JSON.parse(localStorage.getItem("token"));
    let token = userDetails ? userDetails.result.token : null;

    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_BASE_URL}/monthlyreports/search?year=${latestDate.year}&startingmonth=${latestDate.month}&endingmonth=${latestDate.month}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 401) {
        alert("Session Expired. Please login again");
        localStorage.removeItem("token");
        navigate("/login");
      }
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const responseData = await response.json();
      const monthlySale = calculateTotalAmount(
        responseData ? responseData : []
      );
      //console.log(`monthly sale from landing ${monthlySale}`);
      setCurrentMonthTotal(monthlySale ? monthlySale : 0.0);
      setMonthAndYear({
        month: latestDate.month - 1,
        year: new Date().getFullYear(),
      });
      //console.log("response data from landing:", responseData);
    } catch (error) {}
  };

  const fetchLatestDataDate = async () => {
    const userDetails = JSON.parse(localStorage.getItem("token"));
    let token = userDetails ? userDetails.result.token : null;

    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_BASE_URL}/monthlyreports/getlatestDate`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 401) {
        alert("Session Expired, Please login again");
        localStorage.removeItem("token");
        navigate("/login");
      }
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const jsonData = await response.json();
      //console.log("latest data from landing:", jsonData);
      fetchCurrentMonthSales(jsonData);
      dataFetch({
        month: new Date().getMonth(),
        year: new Date().getFullYear(),
      });

      // fetchData(latestDate);
    } catch (error) {}
  };

  React.useEffect(() => {
    const userDetails = JSON.parse(localStorage.getItem("token"));
    let role = userDetails ? userDetails.result.role : null;
    if (role === "REGULAR_USER") {
      navigate("/redirect");
    } else {
      if (apiData == null) {
        // dataFetch({month:new Date().getMonth(),year:new Date().getFullYear()})
        fetchLatestDataDate();
      }
    }
  }, []);

  React.useEffect(() => {
    if (apiData != null) {
      setChartData(apiData);
      setPieChartData(apiData);
      const currentYear = new Date().getFullYear();
      // const currentMonth = new Date().getMonth();
      const currentYearTotalSales = calculateYearlyTotal(apiData[1]);
      setCurrentYearTotal(
        currentYearTotalSales === 0 ? 0 : currentYearTotalSales[currentYear]
      );
      const previousYearTotalSales = calculateYearlyTotal(apiData[2]);
      setPreviousYearTotal(
        previousYearTotalSales === 0
          ? 0
          : previousYearTotalSales[currentYear - 1]
      );
      // const monthlyTotal = processData(apiData[1],stokistData)
      // setCurrentMonthTotal(monthlyTotal[currentMonth].monthlyTotal)

      const dataForBarChart = processYearComparisonData(
        apiData[1],
        stokistData
      );
      setStokistBarChartData(dataForBarChart);

      const processedRepData = process_Rep_data(apiData[0]);
      const sortedRepData = repSortByTotalAmount(processedRepData);
      setTopRepTable(sortedRepData.slice(0, 6));
    }
  }, [apiData]);
  // console.log("api dta",apiData[0])

  return (
    <div className="min-h-full w-full flex flex-col p-4 gap-3 bg-cover bg-center justify-between bg-slate-100 ">
      <div className="">
        <h1 className=" ml-5 mt-1 text-5xl font-bold font-Montserrat text-skin-base">
          HELLO 👋
        </h1>
        <div className="flex ml-5 mb-5 mt-5 gap-3  justify-between ">
          <ActionAreaCard
            icon={<BsCurrencyRupee />}
            heading={`${monthAndYear.year} Total Sales`}
            subheading={`${
              currentYearTotal ? currentYearTotal.toFixed(0) : 0
            } Rs.`}
            top={true}
          />
          <ActionAreaCard
            icon={<SlCalender />}
            heading={`Total Sales in ${monthData[monthAndYear.month].label}`}
            subheading={`${
              currentMonthTotal ? currentMonthTotal.toFixed(0) : 0
            } Rs.`}
            top={true}
          />
          <ActionAreaCard
            icon={<BsCurrencyRupee />}
            heading={`${monthAndYear.year - 1} Total Sales`}
            subheading={`${
              preveiousYearTotal ? preveiousYearTotal.toFixed(0) : 0
            } Rs.`}
            top={true}
          />
        </div>

        <div className="flex flex-col lg:flex-row gap-6">
          {/* Chart Container - Full width on mobile, 2/3 on desktop */}
          <div className="w-full lg:w-2/3 bg-[#c0f0e2] rounded-lg shadow-lg p-4">
            {chartData && <TotalSalesLineChart apiData={apiData} />}
          </div>

          {/* Stats Cards - Grid on mobile, stack on desktop sidebar */}
          <div className="w-full lg:w-1/3 flex flex-col gap-4">
            <ActionAreaCard
              icon={<BiCoinStack />}
              heading="Total Stockists"
              subheading={"10"}
              top={false}
              content={totalStokist}
            />
            <ActionAreaCard
              icon={<BiSolidCapsule />}
              heading="Total Products"
              subheading="80"
              top={false}
              content={totalProducts}
            />
            <ActionAreaCard
              icon={<BiSolidBriefcase />}
              heading="Total Employees"
              subheading="7"
              top={false}
              content={totalReps}
            />
            <ActionAreaCard
              icon={<BiFirstAid />}
              heading="Total Doctors"
              subheading="1475923.45 Rs"
              top={false}
              content={totalDoctors}
            />
          </div>
        </div>
      </div>
      <div className="flex gap-32   mb-3 overflow-clip ml-5  ">
        <div className="flex mt-11 w-full mb-10  h-[85vh] rounded-lg shadow-lg uppercase bg-[#c0f0e2] opacity-90 flex-1">
          <div className="w-full flex items-center justify-center">
            {" "}
            {/* <SimpleLineChart second = {true}/> */}
            {stokistBarChartData && (
              <StokistTable
                chartData={stokistBarChartData}
                stokistData={stokistData}
              />
            )}
          </div>
        </div>
      </div>
      <div className="w-full h-full">
        <div className="flex flex-col bg-gradient-to-br from-emerald-100 via-[#c0f0e2] to-teal-100 rounded-2xl shadow-xl overflow-hidden transition-all duration-300 hover:shadow-2xl pb-10">
          {/* Header Section */}
          <header className="bg-skin-button backdrop-blur-sm m-4 p-6 rounded-xl border border-white/20">
            <div className="flex items-center gap-3">
              {/* <Trophy className="w-8 h-8 text-yellow-500" /> */}
              <h3 className="font-bold text-xl sm:text-2xl md:text-3xl text-gray-800 bg-clip-text">
                {`Top Employees of ${new Date().getFullYear()}`}
              </h3>
            </div>
          </header>

          {/* Content Section */}
          <div className="flex-1 p-4 overflow-hidden">
            <div className="bg-white/80 backdrop-blur-sm rounded-xl shadow-inner h-full transition-all duration-300 hover:bg-white/90">
              <div className=" overflow-auto custom-scrollbar p-3">
                {topRepTable && <RankingTable topRepData={topRepTable} />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Landing;
